import { DOCUMENT } from '@angular/common';
import {
	Component,
	contentChild,
	ElementRef,
	HostListener,
	inject,
	Input,
	signal,
	ViewEncapsulation,
	effect,
	SimpleChanges,
	input
} from '@angular/core';
import { CommonModule } from '@angular/common';
// import { MatExpansionModule } from '@angular/material/expansion';
import { ActivatedRoute, Event as Event_route, NavigationEnd, Router, RouterLink, RouterModule } from '@angular/router';
import { BuscardorhomeComponent } from '../buscardorhome/buscardorhome.component';
import { FormularioBuscadorComponent } from '../formulario-buscador/formulario-buscador.component';
import { filter } from 'rxjs';
import { ComprarService } from '../../services/bottonComprar.service';
import { EcommerceService } from '../../services/ecommerce-state.service';

@Component({
	selector: 'app-buscardorhome-mobile',
	standalone: true,
	// imports: [BuscardorhomeComponent, MatExpansionModule, FormularioBuscadorComponent, RouterLink, RouterModule],
	imports: [BuscardorhomeComponent, FormularioBuscadorComponent, RouterLink, RouterModule, CommonModule],
	templateUrl: './buscardorhome-mobile.component.html',
	encapsulation: ViewEncapsulation.None
})
export class BuscardorhomeMobileComponent {
	private route = inject(ActivatedRoute);
	private document = inject(DOCUMENT);
	private router = inject(Router);
	readonly panelOpenState = signal(false);
	private elementRef = inject(ElementRef);
	public ecommerce = inject(EcommerceService);
	// codigoEcommerceVuelta: number = 0;
	// codigoSig = this.ecommerce.codigo;
	isOpen = signal(false);
	fjfjf = contentChild('buscardor');
	info = signal<any>(null);
	// codigoEcommerceVuelta = input<string | null>(null);
	@Input() codigoEcommerceVuelta: any = 0;
	slug = 'huaraz';
	constructor(private comprarService: ComprarService) {
		effect(() => {
			// this.codigoEcommerceVuelta = this.ecommerce.codigo();
			// console.log('Código cambió:', this.codigoEcommerceVuelta);
			// si necesitas convertir a número:
			// const codigoNum = Number(nuevoValor);
		});
		// effect(
		// 	() => {
		// 		const dataDesdeBoton = this.comprarService.compraInfo();
		// 		dataDesdeBoton.desdeBoton;
		// 		if (dataDesdeBoton.desdeBoton) {
		// 			this.isOpen.set(dataDesdeBoton.open);
		// 			console.log(this.isOpen(), dataDesdeBoton.desdeBoton, dataDesdeBoton.open);
		// 		}
		// 	},
		// 	{ allowSignalWrites: true }
		// );
	}
	esCiudadRoja(): boolean {
		const ciudadesRojas = ['huancayo', 'oxapampa', 'chiclayo'];
		return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	}
	esCiudadHuaraz(): boolean {
		const ciudadesRojas = ['huaraz', 'chiclayo'];
		return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	}
	esBotonComprarAbajo(): boolean {
		const ciudadesRojas = ['huancayo', 'huaraz', 'chiclayo'];
		return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	}
	// esIconoArriba(): boolean {
	// 	const ciudadesRojas = ['huancayo', 'huaraz', 'chiclayo'];
	// 	return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	// }
	// abrirArriba(): boolean {
	// 	const ciudadesRojas = ['huancayo'];
	// 	return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	// }

	ngOnInit() {
		this.router.events.subscribe((event: Event_route) => {
			this.isOpen.set(false);
		});
	}
	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.isOpen.set(false);
		}
	}
	@HostListener('window:scroll', [])
	onWindowScroll() {}
	togglePopup() {
		const data = { desdeBoton: false, open: false };
		this.comprarService.setCompraInfo(data);
		this.isOpen.set(!this.isOpen());
	}
}
